"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckTradePwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var CheckTradePwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(CheckTradePwd, _super);
    function CheckTradePwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验是否设置交易密码';
        _this.code = '101017';
        _this.desc = '校验是否设置交易密码';
        _this.requestParams = new password_1.CheckTradePwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return CheckTradePwd;
}(service_1.BaseService));
exports.CheckTradePwd = CheckTradePwd;
//# sourceMappingURL=checkTradePwd.js.map